export const MUSIC_VIDEO_REPORT_URL = 'https://music-videos-reporting.spotifycdn.com/report.html';
export const COURSE_REPORT_URL = 'https://learning-public-assets-cdn.spotifycdn.com/legal/report.html';
